import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { CfaService } from './cfa.service';
import { PredefinedSegment } from './cfa.service';

@Injectable({ providedIn: 'root' })
export class ImportManagerService {
    private readonly _cfaService = inject(CfaService);

    private importModal = new Subject<boolean>();
    private importTask = new Subject<Awaited<ReturnType<CfaService["pingImportSubscribers"]>>>();
    importModal$ = this.importModal.asObservable();
    importTask$ = this.importTask.asObservable();

    openModal() {
        this.importModal.next(true);
    }

    checkPendingTask() {
        const pendingTaskId = localStorage.getItem("pending-csv-import");
        if (pendingTaskId) {
            this._cfaService.pingImportSubscribers(pendingTaskId).then(res => {
                this.importTask.next(res);
                this.importModal.next(true);
                localStorage.removeItem("pending-csv-import");
            });
        }
    }

    upload(file: File, settings: {segments?: PredefinedSegment[], forceWelcomeAutomation?: boolean} = {}) {
        (async () => {
            try {
                const formData = new FormData();
                formData.append("file", file, file.name);
                if (settings.segments) {
                    formData.append("segments", JSON.stringify(settings.segments));
                }
                if (settings.forceWelcomeAutomation) {
                    formData.append("forceWelcomeAutomation", "1");
                }
        
                const {taskId} = await this._cfaService.importSubscribers(formData);
                localStorage.setItem("pending-csv-import", taskId);
                const [output] = await Promise.all([
                    this._cfaService.pingImportSubscribers(taskId),
                    new Promise(resolve => setTimeout(resolve, 4000))
                ]);
                this.importTask.next(output);
                this.importModal.next(true);
                localStorage.removeItem("pending-csv-import");
            }
            catch (err) {
                //This catch handles max attempts reached. Don't show error modal for it.
                // this.importTask.next({status: "failed"});
                // this.importModal.next(true);
                // localStorage.removeItem("pending-csv-import");
            }
        })();
    }
}